var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeaceofMind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1375_2721)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2734 37.2861L29.9367 39.6058C29.937 39.606 34.376 37.286 34.3766 37.2869L34.3774 37.2861C34.3821 37.2877 34.3859 37.2885 34.3875 37.2901M38.9821 39.913C40.5628 41.0933 41.8558 42.6845 41.8558 45M32.4044 33.8379V34.4342C32.4044 35.7273 33.6466 36.8552 34.3908 37.2909C35.3779 37.8686 36.8907 38.5174 38.2969 39.435",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3493 26.4561H36.222C36.222 30.0009 33.4073 34.7655 29.9352 34.7655C26.463 34.7655 23.6484 30.0009 23.6484 26.4561H29.5212",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5961 33.9508V34.4341C27.5961 35.727 26.3541 36.8551 25.61 37.2907C23.3072 38.639 18.1445 40.3741 18.1445 44.9999M29.8967 24.1485L29.896 24.1491C29.896 24.1491 27.0928 23.7869 25.7509 21.6925C24.409 19.5987 25.2761 16.5958 25.2761 16.5958C25.2761 16.5958 26.692 16.7779 28.0177 17.5586M31.786 17.5678C33.1163 16.7798 34.5432 16.5957 34.5432 16.5957C34.5432 16.5957 35.4098 19.5986 34.0678 21.6924C32.7259 23.7868 29.9233 24.1491 29.9233 24.1491C29.9233 24.1491 29.9226 24.1477 29.9213 24.1445",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9293 24.1587C29.9293 24.1587 27.8291 25.0057 26.028 24.215C24.2269 23.4244 22.9141 21.3372 22.9141 21.3372C22.9141 21.3372 24.0478 20.9141 25.3366 20.8545",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4714 20.8755C35.5669 20.9377 36.4295 21.3105 36.4295 21.3105C36.4295 21.3105 35.5954 23.4732 33.7878 24.2486C31.9802 25.0241 29.8865 24.1586 29.8865 24.1586M39.4256 21.6595H45M40.0116 19.805H43.1494M38.6639 23.4541H41.8018M20.5744 21.6595H15M19.9884 19.805H16.8506M21.3361 23.4541H18.1982M29.8902 41.3721V42.2176M29.8902 43.0631V43.9086M29.9061 24.0261C29.9061 24.0261 27.5704 22.0331 27.5704 19.5308C27.5704 17.0285 29.8695 15 29.8695 15C29.8695 15 32.2418 17.0285 32.2418 19.5308C32.2418 22.0331 29.9061 24.0261 29.9061 24.0261Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1375_2721",
    x1: 0,
    y1: 30,
    x2: 60,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeaceofMind);
export default __webpack_public_path__ + "static/media/Peace of Mind.06c8a365902258047756457005f85cfd.svg";
export { ForwardRef as ReactComponent };